import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Phone, Mail, ShieldCheck, Smartphone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#ffffff",
        color: "#475569",
        paddingTop: "70px",
        paddingBottom: "32px",
        borderTop: "1px solid #e2e8f0",
      }}
    >
      <div className="container">
        <div className="row g-4 mb-5">
          {/* Brand Column */}
          <div className="col-lg-4 col-md-12 mb-3 mb-lg-0">
            <Link
              to="/"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                textDecoration: "none",
                marginBottom: "14px",
              }}
            >
              <img
                src="assets/1024.png"
                alt="EMIBOOK"
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                }}
              />
              <span
                style={{
                  fontFamily: "var(--font-display)",
                  fontWeight: 700,
                  fontSize: "1.15rem",
                  color: "#0f172a",
                  letterSpacing: "-0.02em",
                }}
              >
                EMIBOOK
              </span>
            </Link>

            <p
              style={{
                color: "#64748b",
                fontSize: "0.88rem",
                lineHeight: 1.6,
                maxWidth: "320px",
                marginBottom: "16px",
              }}
            >
              EMIBOOK is an EMI and loan management system created by{" "}
              <strong>S R R Enterprise</strong> for streamlining loans, automating digital
              receipts, and empowering lenders.
            </p>

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "4px 10px",
                background: "#ecfdf5",
                border: "1px solid #a7f3d0",
                borderRadius: "6px",
                color: "#059669",
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            >
              <ShieldCheck size={13} /> 7-day refund policy
            </div>
          </div>

          {/* Product Links */}
          <div className="col-lg-2 col-md-4 col-6">
            <h5
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "0.85rem",
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Product
            </h5>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
              <li>
                <HashLink smooth to="#overview" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  Overview
                </HashLink>
              </li>
              <li>
                <HashLink smooth to="#how-it-works" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  How It Works
                </HashLink>
              </li>
              <li>
                <HashLink smooth to="#features" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  Features
                </HashLink>
              </li>
              <li>
                <HashLink smooth to="#faq" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  FAQ
                </HashLink>
              </li>
            </ul>
          </div>

          {/* Company & Legal */}
          <div className="col-lg-3 col-md-4 col-6">
            <h5
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "0.85rem",
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Company & Legal
            </h5>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
              <li>
                <HashLink smooth to="#about" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  About Us
                </HashLink>
              </li>
              <li>
                <Link to="/privacy-policy" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" style={{ color: "#64748b", textDecoration: "none", fontSize: "0.88rem" }}>
                  Pricing & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/delete-account" style={{ color: "#dc2626", textDecoration: "none", fontSize: "0.88rem", fontWeight: 500 }}>
                  Delete Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div className="col-lg-3 col-md-4 col-12">
            <h5
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "0.85rem",
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Contact
            </h5>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
              <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Phone size={14} color="#2563eb" />
                <a href="tel:9036770772" style={{ color: "#0f172a", fontWeight: 600, textDecoration: "none", fontSize: "0.9rem" }}>
                  +91 9036770772
                </a>
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Mail size={14} color="#7c3aed" />
                <a href="mailto:support@emibook.in" style={{ color: "#0f172a", fontWeight: 600, textDecoration: "none", fontSize: "0.9rem" }}>
                  support@emibook.in
                </a>
              </li>
              <li style={{ marginTop: "4px" }}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.emibook.app&hl=en"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    color: "#0f172a",
                    fontSize: "0.82rem",
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  <Smartphone size={13} color="#2563eb" /> Google Play App
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom copyright */}
        <div
          style={{
            paddingTop: "20px",
            borderTop: "1px solid #f1f5f9",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
            fontSize: "0.82rem",
            color: "#94a3b8",
          }}
        >
          <div>
            © {new Date().getFullYear()} <strong>S R R Enterprise</strong>. All rights reserved.
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <Link to="/privacy-policy" style={{ color: "#94a3b8", textDecoration: "none" }}>
              Privacy
            </Link>
            <Link to="/refund-policy" style={{ color: "#94a3b8", textDecoration: "none" }}>
              Refund Policy
            </Link>
            <HashLink smooth to="#contact" style={{ color: "#94a3b8", textDecoration: "none" }}>
              Contact
            </HashLink>
          </div>
        </div>
      </div>
    </footer>
  );
}
